export default "__VITE_ASSET__BIAVGlTC__"